var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20751_105515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7266 9.98283L16.0922 12.6868L19.2734 14.7195L19.8268 9.99989L19.2734 5.38672L16.0312 7.17241L13.7266 9.98283Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.2801V18.3019C0 19.2202 0.745403 19.9657 1.66389 19.9657H5.68569L6.51848 16.927L5.68569 14.2801L2.92645 13.4473L9.47867e-05 14.2801H0Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68569 0L0 5.68569L2.92664 6.51649L5.68569 5.68569L6.50332 3.07479L5.68569 0Z",
    fill: "#E94235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.2823H5.68559V5.68555H0V14.2823Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9056 2.4076L19.2734 5.38731V14.72L22.9205 17.7113C23.4665 18.139 24.2652 17.7492 24.2652 17.0552V3.05044C24.2652 2.34873 23.4475 1.96087 22.9055 2.40769",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7276 9.98242V14.2799H5.68604V19.9655H17.6106C18.5291 19.9655 19.2744 19.22 19.2744 18.3017V14.7191L13.7276 9.98242Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6106 0H5.68604V5.68569H13.7276V9.98313L19.2745 5.38692V1.66398C19.2745 0.745498 18.5291 9.47867e-05 17.6106 9.47867e-05",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20751_105515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.2654,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeet);
export default __webpack_public_path__ + "static/media/meet.072b3b7e0044c1e04ace22262c851841.svg";
export { ForwardRef as ReactComponent };